import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useNavigate } from 'react-router-dom';
import { COLUMNS } from '../dashboard/columns';
import { formatSchemeReasonLabel } from '../dashboard/reasonCode';
import { caseLink, toStatusLabel } from '../status/displayStatus';
import { reasonText } from '../status/reasonText';
import { formatAmount, formatUsDate } from '../util/formatters';
const renderCell = (id, item) => {
    switch (id) {
        case 'status':
            return {
                value: toStatusLabel(item.defenseStatus, item.defenseResult),
                className: 'text-sm'
            };
        case 'defenseEndDate':
            return { value: formatUsDate(item.defensePeriodEndsAt) };
        case 'chargebackPsp':
            return {
                value: item.pspReference,
                className: 'font-mono text-xs'
            };
        case 'originalPsp':
            return {
                value: item.originalReference ?? '—',
                className: 'font-mono text-xs'
            };
        case 'amount':
            return {
                value: formatAmount(item.amount, item.currency),
                className: 'text-right'
            };
        case 'reasonCode': {
            const formatted = formatSchemeReasonLabel(item.chargebackSchemeCode, item.chargebackReasonCode);
            return { value: formatted.length > 0 ? formatted : '—' };
        }
        case 'reason':
            return { value: reasonText(item.reason, item.chargebackReasonCode) };
        case 'propertyId':
            return {
                value: item.propertyId ?? '—',
                className: 'font-mono text-xs'
            };
        case 'reservationId':
            return {
                value: item.reservationId ?? '—',
                className: 'font-mono text-xs'
            };
    }
};
const headerClass = (id) => id === 'amount' ? 'text-right' : '';
export const ChargebackTable = ({ cases, loading, visibleColumns }) => {
    const navigate = useNavigate();
    const columns = COLUMNS.filter(c => visibleColumns.has(c.id));
    const colspan = columns.length;
    return (_jsxs("table", { className: "table table-zebra table-sm w-full", children: [_jsx("thead", { children: _jsx("tr", { children: columns.map(c => (_jsx("th", { className: headerClass(c.id), children: c.label }, c.id))) }) }), _jsx("tbody", { children: loading ? (_jsx("tr", { children: _jsx("td", { colSpan: colspan, children: "Loading\u2026" }) })) : cases.length === 0 ? (_jsx("tr", { children: _jsx("td", { colSpan: colspan, children: "No chargebacks match the current filters." }) })) : (cases.map(item => {
                    const href = caseLink(item.pspReference);
                    // Full-row navigation is a convenience — the real link lives in the
                    // first cell so cmd/middle-click, screen readers, and keyboard nav
                    // all work. Clicks inside the first cell propagate to the anchor,
                    // so we suppress the row-level handler in that case.
                    const openFromRow = (e) => {
                        const target = e.target;
                        if (target.closest('a')) {
                            return;
                        }
                        navigate(href);
                    };
                    return (_jsx("tr", { title: `View case ${item.pspReference}`, onClick: openFromRow, className: "cursor-pointer", children: columns.map((c, index) => {
                            const cell = renderCell(c.id, item);
                            if (index === 0) {
                                return (_jsx("td", { className: cell.className, children: _jsx(Link, { to: href, "aria-label": `View case ${item.pspReference}`, className: "block no-underline text-inherit", children: cell.value }) }, c.id));
                            }
                            return (_jsx("td", { className: cell.className, children: cell.value }, c.id));
                        }) }, item.pspReference));
                })) })] }));
};
